<template>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-subheader ">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h3 class="m-subheader__title m-subheader__title--separator">
                        Delete Reason 
                    </h3>
                    <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                        <li class="m-nav__item m-nav__item--home">
                            <router-link exact :to="{ name: 'home' }" class="m-nav__link m-nav__link--icon">
                                <i class="m-nav__link-icon la la-home"></i>
                            </router-link>
                        </li>
                        <li class="m-nav__separator">
                            -
                        </li>
                        <li class="m-nav__item">
                            <router-link exact :to="{ name : 'reason_delete' }" class="m-nav__link"><span
                                    class="m-nav__link-text">Delete Reason</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="m-content">
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Delete Reason table
                                <small>
                                    List of all Reason
                                </small>
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                    </div>
                </div>
                <div class="m-portlet__body">
                    <!--begin: Search Form -->
                    <div class="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
                        <div class="row align-items-center">
                            <div class="col-xl-8 order-2 order-xl-1">
                                <div class="form-group m-form__group row align-items-center">
                                    <div class="col-md-4">
                                        <div class="m-input-icon m-input-icon--left">
                                            <input type="text" class="form-control m-input m-input--solid"
                                                   v-model="search"
                                                   placeholder="Search..." id="generalSearch">
                                            <span class="m-input-icon__icon m-input-icon__icon--left">
                                                <span>
                                                    <i class="la la-search"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 order-1 order-xl-2 m--align-right">
                                <button v-b-modal="'ReasonModal'"
                                        class="btn btn-brand m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                                    <span>
                                        <i class="la la-plus"></i>
                                        <span>New Reason</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="alert alert-success alert-dismissible" role="alert" v-if="alertCreated">
                        <button type="button" class="close" aria-label="Close" @click="alertCreated=false"></button>
                        New reason created successfully
                    </div>
                    <div class="alert alert-success alert-dismissible" role="alert" v-if="alertUpdated">
                        <button type="button" class="close" aria-label="Close" @click="alertUpdated=false"></button>
                        Reason updated successfully
                    </div>
                    <!--end: Search Form -->
                    <div class="table-responsive">
                    <table class="table table-inverse" v-if="reasons.length > 0">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th></th>
                            <th>Title</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="reason,index in filteredReasons">
                            <td>{{index + 1}}</td>
                            <td style="width: 100px;">
                                <button title="Up" class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" 
                                    :disabled="index == 0"
                                    @click="updateOrder(reason, index, 'up')">
                                    <i class="la la-chevron-circle-up"></i>
                                </button>
                                <button title="Down" class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" 
                                    :disabled="index == reasons.length - 1"
                                    @click="updateOrder(reason, index, 'down')">
                                    <i class="la la-chevron-circle-down"></i>
                                </button>
                            </td>
                            <td>{{ reason.title }}</td>
                            <td style="width: 100px;">
                                <button title="Edit details"
                                        class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                                        v-b-modal="'ReasonModal'"
                                        @click="updateReason(reason.id)">
                                    <i class="la la-edit"></i>
                                </button>
                                <button title="Delete" @click="deleteItem(reason.id)"
                                        class="btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill">
                                    <i class="la la-trash"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                    <b-pagination v-if="total > 0 && total > pageSize" align="right" size="md" :total-rows="total"
                                  v-model="page" :per-page="pageSize">
                    </b-pagination>
                </div>

            </div>
            <reason-modal @clear-id="clearId"
                            @clicked-reload="getList"
                            @show-create-success-alert="showCreateSuccessAlert"
                            @show-update-success-alert="showUpdateSuccessAlert"
                            v-bind:reasonId="reasonId"
            />
        </div>
    </div>
</template>

<script>
    import ReasonApi from '../../api/reason_delete';
    import ReasonModal from './ReasonModal';

    export default {
        components: {
            ReasonModal
        },
        name: "Reason",
        data() {
            return {
                error: false,
                alertCreated: false,
                alertUpdated: false,
                message: null,
                page: 1,
                total: 0,
                search: '',
                pageSize: 100000,
                reasonId: null,
                reasons: [],
                createdAlert: "New Reason created successfully",
                updatedAlert: "Reason updated successfully"
            }
        },
        computed: {
            filteredReasons: function () {
                return this.reasons.filter((reason) => {
                    if (reason.title.match(this.search)) {
                        return reason;
                    }
                });
            }
        },
        watch: {
            page(val) {
                this.getList()
            },
            pageSize(val) {
                this.getList()
            }
        },
        beforeMount() {
            this.getList()
        },
        methods: {
            updateReason(id) {
                this.reasonId = id;
                this.$bvModal.show('ReasonModal');
            },
            getList() {
                ReasonApi.getReason(this, {
                    page: this.page,
                    pageSize: this.pageSize
                }, (context) => {
                })
            },
            updatePageSize(val) {
                this.pageSize = parseInt(val);
            },
            clearId() {
                this.reasonId = null;
                this.getList();
            },
            showCreateSuccessAlert() {
                this.alertCreated = true;
                this.alertUpdated = false;
            },
            showUpdateSuccessAlert() {
                this.alertCreated = false;
                this.alertUpdated = true;
            },
            deleteItem(id) {
                let approve = confirm(`Do you want to remove this reason?`);
                if (approve !== false) {
                    ReasonApi.removeReason(this, id, (context) => {
                        this.getList();
                        this.alertCreated = false;
                        this.alertUpdated = false;
                    });
                }
            },
            updateOrder(reason, index, type) {
                const indexAction = type == 'up' ? index - 1 : index + 1
                const data = {
                    id1: reason.id,
                    order1: this.reasons[indexAction].order || indexAction + 1,
                    title1: reason.title,
                    id2: this.reasons[indexAction].id,
                    order2: reason.order || index + 1,
                    title2: this.reasons[indexAction].title,
                }
                ReasonApi.updateOrder(this, data, (context) => {
                    this.getList()
                })
            }
        }
    }
</script>

<style scoped>

</style>